module.exports = __webpack_public_path__ + "static/media/zwan-logo.6bf8992d.svg";